export default __webpack_public_path__ + "static/media/niger.a61227dc.svg";